import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCheckCircle } from "react-icons/fa";
import { useSelector } from 'react-redux';
import { AiTwotoneEye } from "react-icons/ai";
import { AiTwotoneEyeInvisible } from "react-icons/ai";
import { ProductAPI } from '../../api/ProductAPI';
import { Privileges } from '../../util/PrivilegeConstants';
import { isClubOwner, isClubStaff,isUser } from '../../util/UserRoles';
import { SubscriptionAPI } from '../../api/SubscriptionAPI';

const SubscriptionItem = ({ privileges, product, subscriptionInfo, setMessage, startLoading, finishLoading, setRefreshProduct }) => {
    const userInfo = useSelector((store) => store.user.userInfo);
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const navigate = useNavigate();

    const handlePurchase = (event) => {
        event.preventDefault();

        if (product.productId !== subscriptionInfo.productId && subscriptionInfo?.status === 'active') {
            if (typeof setMessage === 'function') {
                setMessage({ type: 'warning', content: "You cannot buy two plans at once." });
                setTimeout(() => {
                    setMessage({ type: '', content: '' });
                }, 4000);
            }
        }
    }

    const handleUpdatePlanIsVisibleToNewUser = async () => {
        try {
            startLoading('loading1');
            await ProductAPI.patchUpdateProductIsVisible({
                planId: product?.planId,
                isVisible: !product.visible
            });
            setRefreshProduct(true);
        } catch (error) {
            finishLoading('loading1');
        }
    }
    const handlePurchaseButton = async () => {
        try {
            startLoading('loading1');
            const planInfo = {
                priceId: product?.memberPriceId,
                planId: product?.planId,
                clubActivationPriceId: product?.clubRegistrationPriceId,
                userId: userInfo.userId,
                clubId: selectedClub.clubId,
                subQuantity: "1",
                isSubForPlatform: false,
                amount: product?.membershipAmount
            }
            const subscriptionResponse = await SubscriptionAPI.postPurchasePlan(planInfo);
            navigate('/subscription-connected', {
                state: {
                    membershipAmount: product?.membershipAmount,
                    clubActivationFee: product?.clubRegistrationAmount,
                    clientSecretKey: subscriptionResponse.Data.clientSecretKey,
                    processingFee: subscriptionResponse.Data.processingFee,
                    totalAmount: subscriptionResponse.Data.totalAmount
                },
            })
        } catch (e) {

        }finally{
            finishLoading('loading1');
        }
        
    }
    if (isUser(userInfo) && subscriptionInfo?.planName !== product.planName && !product?.visible) {
        return (<></>)
    }
    return (
        <div data-testid="subscription_plan_conatiner" className={(subscriptionInfo?.status === 'active' && subscriptionInfo?.priceId === product.memberPriceId)
            ?
            "subscription_plan_conatiner active"
            :
            "subscription_plan_conatiner"
        }>
            <div className="club_plan_inner">
                {privileges?.MANAGE_CLUB_PLAN?.includes(Privileges.MODIFY) &&
                    <>
                        {product?.visible ?
                            <AiTwotoneEye className='plan_visible_btn' onClick={handleUpdatePlanIsVisibleToNewUser} />
                            :
                            <AiTwotoneEyeInvisible className='plan_visible_btn' onClick={handleUpdatePlanIsVisibleToNewUser} />
                        }
                    </>}
                <div data-testid="club_sub_active_badge" className={!isClubOwner(userInfo) && (subscriptionInfo?.status === 'active' && subscriptionInfo.priceId === product.memberPriceId) ? "club_sub_active_badge" : "club_sub_active_badge hide"}>
                    <p>active</p>
                </div>
                <span className="club_plan_pricing">
                    <span>
                        ${Number(product?.membershipAmount) / 100}<small>/mo</small>
                    </span>
                </span>
                {product.planType === 'subscription'
                    ?
                    <p className="club_plan_title">{product?.planName}</p>
                    :
                    <p className="club_plan_title">Pay as you go</p>
                }
                <span className='club_plan_ho_line' ></span>
                <ul className="club_plan_features">
                    {product?.weekdayInfo?.map((item, index) =>
                        <li key={index}>
                            <FaCheckCircle data-testid="club_plan_icon" className="club_plan_icon" />
                            <span>Weekdays: <strong>{item.startTime} - {item.endTime}</strong>- <strong>${item.amount}/hr</strong></span>
                        </li>)}
                    {product?.weekendInfo?.map((item, index) =>
                        <li key={index}>
                            <FaCheckCircle data-testid="club_plan_icon" className="club_plan_icon" />
                            <span>Weekends: <strong>{item.startTime} - {item.endTime}</strong>- <strong>${item.amount}/hr</strong></span>
                        </li>)}
                    {product.advanceBooking != 0 &&
                        <li>
                            <FaCheckCircle data-testid="club_plan_icon" className="club_plan_icon" />
                            <span>Advance Booking: {product.advanceBooking} Days</span>
                        </li>}
                    <li>
                        <FaCheckCircle className="club_plan_icon" />
                        <span>Unlimited Reservations</span>
                    </li>
                </ul>
                {(!isClubOwner(userInfo) && !isClubStaff(userInfo)) &&
                    <div data-testid="club_plan_action1"
                        className={(subscriptionInfo?.status === 'active' && subscriptionInfo?.priceId !== product?.memberPriceId) ? "club_plan_action" : "club_plan_action hide"}>
                        <button data-testid="club_plan_button1" onClick={subscriptionInfo?.status === 'active' ? handlePurchase : handlePurchaseButton} className="club_plan_button">
                            Purchase
                        </button>
                    </div>}
                {!isClubStaff(userInfo) &&
                    <div data-testid="club_plan_action2"
                        className={(subscriptionInfo?.status !== 'active') ? "club_plan_action" : "club_plan_action hide"}>
                        {!isClubOwner(userInfo) &&
                            <button data-testid="club_plan_button2" onClick={handlePurchaseButton} className="club_plan_button">
                                Purchase
                            </button>
                        }
                    </div>}
            </div>
        </div>
    )
}
export default SubscriptionItem